import { MapboxStatic } from 'js/academia_components/maps/mapbox_static';
import {
  FollowButton,
  MessageButton,
} from 'js/academia_components/buttons/social_buttons';
import $image_url from 'js/utils/image_url';
import { useAutoProps } from 'js/auto_props/react/AutoPropsProvider';

export const UserHeader = ({
  id,
  first_name,
  url,
  photo,
  display_name,
  user_location,
  onProfileClick,
}) => {
  const followedUsers = useAutoProps('UserFollows')?.followedUsers;
  const isFollowing = followedUsers?.some((user) => user.id === id);

  return (
    <div className="wp-usercard-header">
      <div className="wp-usercard-header-media">
        {photo && (
          <div className="wp-usercard-header-media__photo responsive_margins">
            <a href={url} onClick={onProfileClick}>
              <img src={photo} alt="profile avatar" />
            </a>
          </div>
        )}

        <div className="wp-usercard-header-media__map">
          <MapboxStatic
            latitude={user_location && user_location.latitude}
            longitude={user_location && user_location.longitude - 0.7}
          />
        </div>

        {photo && <div className="wp-usercard-header-media__photo-spacer" />}
      </div>

      <div className="wp-usercard-header-name responsive_margins truncate">
        <a href={url} onClick={onProfileClick}>
          {display_name}
        </a>
      </div>

      <div className="wp-usercard-header-social responsive_margins">
        <FollowButton
          textOnly
          following={isFollowing}
          source="readers_page"
          userId={id}
          firstName={first_name}
        />
        <MessageButton userId={id} textOnly />
      </div>
    </div>
  );
};

export const AnonHeader = ({ id, display_name, user_location }) => {
  const photo = $image_url(
    'analytics/profile_visitors/avatar_' + ((id % 12) + 1) + '.svg',
  );

  return (
    <div className="wp-usercard-header">
      <div className="wp-usercard-header-media">
        <div className="wp-usercard-header-media__photo responsive_margins">
          <img src={photo} alt="profile avatar" />
        </div>

        <div className="wp-usercard-header-media__map">
          <MapboxStatic
            latitude={user_location && user_location.latitude}
            longitude={user_location && user_location.longitude - 0.7}
          />
        </div>

        <div className="wp-usercard-header-media__photo-spacer" />
      </div>

      <div className="wp-usercard-header-name responsive_margins truncate">
        {display_name}
      </div>
    </div>
  );
};
